export interface WithdrawPayload {
  registrationIds: string[];
}

export const WITHDRAW_API = '/v1/tournaments/withdraw';
